import { render } from "./NoticeItemComponent.vue?vue&type=template&id=52aaaf49"
import script from "./NoticeItemComponent.vue?vue&type=script&lang=js"
export * from "./NoticeItemComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__